import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`] || color;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4835 2.17026C11.7727 1.89562 12.2263 1.89536 12.5158 2.16967C14.5319 4.07976 17.2532 5.24911 20.25 5.24911H20.402C20.726 5.24911 21.0133 5.4571 21.1145 5.76484C21.527 7.01948 21.75 8.35952 21.75 9.75011C21.75 15.6926 17.6863 20.6832 12.1869 22.0984C12.0643 22.13 11.9356 22.13 11.813 22.0984C6.31373 20.6822 2.25 15.6916 2.25 9.74911C2.24898 8.39616 2.46346 7.05168 2.88541 5.76621C2.98769 5.45462 3.28055 5.24561 3.60847 5.25018C6.53492 5.29103 9.36128 4.18565 11.4835 2.17026ZM12.0005 3.72184C9.80566 5.58939 7.03907 6.65657 4.15614 6.74526C3.88602 7.72263 3.74918 8.73286 3.75 9.74851C3.75 14.9225 7.24249 19.2824 12.0001 20.5959C16.7575 19.2833 20.25 14.9241 20.25 9.75011C20.25 8.70762 20.1083 7.69925 19.8437 6.74276C16.8565 6.64927 14.1274 5.52866 12.0005 3.72184ZM15.4359 9.13981C15.773 9.38057 15.8511 9.84898 15.6103 10.186L11.8603 15.436C11.7322 15.6154 11.5316 15.7294 11.3119 15.7476C11.0922 15.7657 10.8756 15.6863 10.7197 15.5304L8.46967 13.2804C8.17678 12.9875 8.17678 12.5127 8.46967 12.2198C8.76257 11.9269 9.23744 11.9269 9.53033 12.2198L11.1543 13.8437L14.3897 9.31418C14.6305 8.97712 15.0989 8.89905 15.4359 9.13981Z"
        fill={colorValue}
      />
    </svg>
  );
};
